import React, { useEffect, useMemo, useState } from 'react'

import {
  DEFAULT_TOKEN_BANNER_URL,
  DEFAULT_TOKEN_ICON_URL,
  getTokenBannerSrcCandidates,
  getTokenIconSrcCandidates,
} from '@/constants/tokenImages'

type TokenMediaVariant = 'icon' | 'banner'

export function TokenMediaImage({
  src,
  address,
  variant = 'icon',
  alt = '',
  className,
  loading,
  style,
}: {
  src?: string | null
  address?: string
  variant?: TokenMediaVariant
  alt?: string
  className?: string
  loading?: 'lazy' | 'eager'
  style?: React.CSSProperties
}) {
  const candidates = useMemo(() => {
    if (variant === 'banner') return getTokenBannerSrcCandidates(src)
    if (!address) {
      const list = [src?.trim(), DEFAULT_TOKEN_ICON_URL].filter((value): value is string => Boolean(value))
      return [...new Set(list)]
    }
    return getTokenIconSrcCandidates(address, src)
  }, [address, src, variant])

  const [activeIndex, setActiveIndex] = useState(0)
  const currentSrc = candidates[Math.min(activeIndex, candidates.length - 1)] ?? DEFAULT_TOKEN_ICON_URL

  useEffect(() => {
    setActiveIndex(0)
  }, [candidates.join('|')])

  return (
    <img
      src={currentSrc}
      alt={alt}
      className={className}
      loading={loading}
      style={style}
      onError={() => {
        if (activeIndex < candidates.length - 1) {
          setActiveIndex((index) => index + 1)
        }
      }}
    />
  )
}
